import React from "react";

interface ChannelInfoIconProps {
  color?: string;
}

const ICON_STYLE = {
  width: "16px",
  height: "16px",
  display: "inline",
  verticalAlign: "middle",
  flexShrink: 0
} as const;

/**
 * Decorative ⓘ glyph for Local / RSN / National channel badges.
 * Always aria-hidden and fixed at 16×16px. Pass `color` to tint all shapes;
 * omit it to inherit from the surrounding CSS context via `currentColor`.
 */
const ChannelInfoIcon: React.FC<ChannelInfoIconProps> = ({ color = "currentColor" }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    style={ICON_STYLE}
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="8" r="1" fill={color} />
    <rect x="11" y="11" width="2" height="6" rx="1" fill={color} />
  </svg>
);

export default ChannelInfoIcon;
